/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-danger */
// @flow
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import * as css from './TextField.scss';

// const onlyHebrewPattern = new RegExp(/^[\u0590-\u05FF 0-9 /\W/g\r\n-]+$/);
// const onlyHebrewPattern2 = new RegExp(/^[\u0590-\u05FF r\n-]+$/);
// const onlyHebrewPatternAdressField = new RegExp(/^[\u0590-\u05FF 0-9 r\n-]+$/);
const emailRegExp = /[^a-zA-Z@. 0-9]/;

type Props = {
	input: {|
		name: string,
		onBlur: Function,
		onChange: Function,
		onDragStart: Function,
		onDrop: Function,
		onFocus: Function,
		value: string | number,
	|},
	meta: {|
		active?: boolean,
		asyncValidating?: boolean,
		autofilled?: boolean,
		dirty?: boolean,
		dispatch?: Function,
		error?: string,
		form?: string,
		initial?: string,
		invalid?: boolean,
		pristine?: boolean,
		submitFailed?: boolean,
		submitting?: boolean,
		touched?: boolean,
		valid?: boolean,
		visited?: boolean,
		warning?: string,
	|},
	inputRef?: { current: ?HTMLInputElement | ?HTMLTextAreaElement } | null,
	className?: string,
	placeholder?: string,
	eventListeners: {|
		onChange?: Function,
		onFocus?: Function,
		onBlur?: Function,
		onKeyDown?: Function,
		onKeyUp?: Function,
	|},
	isTextarea?: boolean,
	textareaType?: number,
	inlineType?: boolean,
	disabled?: boolean,
	clearValue?: boolean,
	maxWordsLength?: number,
	isNumberField?: boolean,
	minNumber: number,
	maxNumber: number,
	type?: string,
	pattern?: string,
	isEmailField?: boolean,
	maxLength?: number,
	isLtr?: boolean,
};

type State = {|
	isFocused: boolean,
	value?: string | number,
	valueState?: number | string,
|};

export default class Input extends React.PureComponent<Props, State> {
	static defaultProps = {
		inputRef: null,
		className: '',
		placeholder: '',
		isTextarea: false,
		textareaType: 1,
		inlineType: false,
		disabled: false,
		clearValue: false,
		maxWordsLength: 1500,
		isNumberField: false,
		type: '',
		pattern: '',
		isEmailField: false,
		maxLength: 10000,
		isLtr: false,
	};

	static getDerivedStateFromProps(props: Props, state: State) {
		if (props.input.value === '') {
			return {
				valueState: '',
			};
		}

		return null;
	}

	constructor(props: Props) {
		super(props);

		this.state = {
			isFocused: false,
			value: props.input.value,
			valueState: '',
		};
	}

	onFocus = (e: SyntheticInputEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		this.setState({ isFocused: true });

		_.invoke(this.props, 'input.onFocus', e);
	};

	onBlur = (e: SyntheticInputEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		this.setState({ isFocused: false });

		_.invoke(this.props, 'input.onBlur', e);
	};

	onChange = (e: SyntheticInputEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value } = e.target;
		// const { maxWordsLength, maxNumber, minNumber, type } = this.props;
		// const { maxWordsLength } = this.props;
		let nextValue = value;

		if (nextValue && this.props.pattern) {
			const regExp = new RegExp(`${this.props.pattern}`, 'i');
			const isMatch = regExp.test(value);
			if (!isMatch) nextValue = this.state.valueState;
			console.info('===***===', isMatch);
			if (isMatch) _.invoke(this.props, 'input.onChange', e);
		}

		// if (nextValue && maxWordsLength) {
		// 	const isMatch =
		// 		nextValue
		// 			.toString()
		// 			.trim()
		// 			.split(/\s+/).length <
		// 		maxWordsLength + 1;
		// 	if (!isMatch) nextValue = this.state.valueState;
		// 	console.info('===1111===', isMatch);
		// 	if (isMatch) _.invoke(this.props, 'input.onChange', e);
		// }
		// _.invoke(this.props, 'input.onChange', e);
		this.setState({ valueState: nextValue });
	};

	validation = (letter: string, event: any) => {
		const { isEmailField } = this.props;
		if (isEmailField && emailRegExp.test(letter)) {
			event.preventDefault();
		}
	};

	render() {
		const {
			className,
			placeholder,
			isTextarea,
			textareaType,
			inlineType,
			disabled,
			clearValue,
			inputRef,
			type,
			// pattern,
			isLtr,
			...rest
		} = this.props;
		const { isFocused } = this.state;
		const { maxLength } = this.props;
		console.info('isFocused', isFocused);
		const value = clearValue ? '' : _.get(rest, 'input.value', '');

		return (
			<label
				className={classNames(
					css.textField,
					(isFocused || value) && css.active,
					isFocused && css.focused,
					this.props.meta.error && css.error,
					className
				)}
			>
				{placeholder && (
					<div
						className={classNames(css.placeholder, isTextarea && css.forTextarea)}
						dangerouslySetInnerHTML={{ __html: placeholder }}
					></div>
				)}
				{isTextarea && (
					<div className={css.textareaWrapper}>
						<textarea
							onChange={this.onChange}
							onFocus={this.onFocus}
							onBlur={this.onBlur}
							// {...rest.input}
							value={this.state.valueState}
							ref={inputRef}
							{...rest.eventListeners}
							className={classNames(textareaType === 1 && css.small, textareaType === 2 && css.big)}
							disabled={disabled}
						></textarea>
					</div>
				)}
				{!isTextarea && (
					<input
						{...rest.input}
						value={this.state.valueState}
						ref={inputRef}
						{...rest.eventListeners}
						onFocus={this.onFocus}
						onBlur={this.onBlur}
						className={classNames(inlineType && css.inline, isLtr && css.ltr)}
						onChange={this.onChange}
						type={type || 'text'}
						maxLength={maxLength}
						autoComplete="off"
					/>
				)}
				{this.props.meta.error && <p className={css.errorMessage}>{this.props.meta.error}</p>}
			</label>
		);
	}
}
